import React from 'react';
import { Avatar, Stack, Typography } from '@mui/material';
import { Groups as GroupsIcon } from '@mui/icons-material';
import { useQuery } from 'react-query';
import API from '@wheeebo/polaris-api';
import { CircleLoader, LoadError } from '../loader';
function GroupPanel({ group, groupId, ...props }) {
    const { data, isLoading, isError } = useQuery(groupId ? API.Groups.getKey(groupId) : '', () => (groupId ? API.Groups.get(groupId) : undefined), { enabled: !group && !!groupId });
    if (!group) {
        if (isLoading) {
            return React.createElement(CircleLoader, null);
        }
        else if (isError) {
            return React.createElement(LoadError, null);
        }
    }
    const content = group || data;
    return (React.createElement(Stack, { gap: 1, direction: "row", sx: { display: 'flex', alignItems: 'center', cursor: 'pointer' }, ...props },
        React.createElement(Avatar, { src: content?.imageUrl, variant: "rounded", sx: { width: 32, height: 32, backgroundColor: 'transparent' } },
            React.createElement(GroupsIcon, { color: "disabled" })),
        React.createElement(Typography, { variant: "body2" }, content?.name)));
}
export default React.memo(GroupPanel);
